import { IAnyObj } from 'constants/types/common.types'

declare global {
  interface Window {
    VK: IAnyObj
    vkRef: any
  }
}

enum VkEvents {
  STARTED = 'started',
  INITED = 'inited',
  ENDED = 'ended',
  ERROR = 'error',
  PLAYING = 'playing',
  PAUSED = 'paused',
  UNSTARTED = 'unstarted',
  TIMEUPDATE = 'timeupdate',
}

const CONTROLS_SHOW_TIME = 3500
const CONTROLS_FIRST_SHOW_TIME = 21600000

export { VkEvents, CONTROLS_SHOW_TIME, CONTROLS_FIRST_SHOW_TIME }
